import facebook from "@/domain/icon/svg/share/facebook";
import twitterX from "@/domain/icon/svg/share/twitter-x";
import telegram from "@/domain/icon/svg/share/telegram";
import copyLink from "@/domain/icon/svg/share/copyLink";
import linkedin from "@/domain/icon/svg/share/linkedin";
import whatsapp from "@/domain/icon/svg/share/whatsapp";
import email from "@/domain/icon/svg/share/email";

export const _icons = {
    facebook,
    twitterX,
    telegram,
    copyLink,
    linkedin,
    whatsapp,
    email
}